const backendUrl = process.env.REACT_APP_BACKEND_URL;

if (!backendUrl) {
  alert(
    "Debe definir la url del backend en REACT_APP_BACKEND_URL dentro del archivo .env"
  );
  throw new Error(`Debe definir REACT_APP_BACKEND_URL en .env`);
}

export const url_base_api = `${backendUrl}`;

const ipfsGatewayUrl = process.env.REACT_APP_IPFS_GATEWAY_URL;

if (!ipfsGatewayUrl) {
  alert(
    "Debe definir la url del gateway de IPFS en REACT_APP_IPFS_GATEWAY_URL dentro del archivo .env"
  );
  throw new Error(`Debe definir REACT_APP_IPFS_GATEWAY_URL en .env`);
}

export const ipfs_gateway_url = `${ipfsGatewayUrl}`;
